import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=87705e00&"
import script from "./Default?vue&type=script&lang=js&"
export * from "./Default?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports